import styled from 'styled-components';

export const StyledLineBreakDivider = styled.div`
  width: 100%;
  visibility: hidden;
  transition: all 300ms ease;
`;
